// extracted by mini-css-extract-plugin
export default {"container":"SolutionPage_container__zHDqF"};